import { render, staticRenderFns } from "./HelpCertificatComponent.vue?vue&type=template&id=730855f2"
import script from "./HelpCertificatComponent.vue?vue&type=script&lang=js"
export * from "./HelpCertificatComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports